export const getTableAndFigureContent = (root, sectionId) => {
  let section = root.querySelector(`${sectionId}`);
  if (!section) return;

  let content;
  if (section.tagName.toLowerCase() === "table") {
    content = section.outerHTML;
  } else {
    content = findFigureContent(section);
  }
  return content;
}

// To walk thru DOM to find any images under fig element
// and combine them into a string to be displayed as modal box content
const findFigureContent = (figureSection) => {
  if (!figureSection) return null;

  const images = figureSection.querySelectorAll("img, svg");
  return Array.from(images)
    .map((img) => img.outerHTML)
    .join("\n");
};

// To walk thru DOM to find the first table found under ditatitle
export const findTableSectionId = (ditatitle) => {
  let current = ditatitle.parentNode?.nextElementSibling;

  while (current) {
    if (current.tagName.toLowerCase() === "table") {
      return current.id;
    }

    const tableInWrapper = current.querySelector("table");
    if (tableInWrapper) {
      return tableInWrapper.id;
    }

    current = current.nextElementSibling;
  }
  return null;
};